import React from 'react'
import styled from 'styled-components'
import PlusIcon from '../../../assets/icons/JSX/PlusIcon'
import Colors from '../../../assets/styles/Colors'
import Responsive from '../../../assets/config/Responsive'
//
//
const AddButton: React.FC<{
  style?: React.CSSProperties
  text?: string
  onClick?: () => void
  disabled?: boolean
  type?: 'submit' | 'button' | 'reset'
}> = ({ style, text, onClick, disabled, type }) => {
  //
  //
  return (
    <Button onClick={onClick} disabled={disabled} type={type ?? 'button'} style={style}>
      <div>
        <PlusIcon />
      </div>
      <span>{text}</span>
    </Button>
  )
}
//
const Button = styled.button`
  border: 0px;
  outline: none;
  user-select: none;
  margin: 0px;
  padding: 0px;
  background-color: transparent;
  color: ${Colors.primaryBlack};
  display: flex;
  justify-content: center;
  align-items: center;

  /* icon div */
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    margin-right: 16px;
    border: solid 1px ${Colors.primaryBlack};
    border-radius: 50%;

    /* icon svg */
    svg {
      height: 15px;
      width: 15px;
      min-width: 15px;
      color: ${Colors.primaryBlack};
    }
  }

  /* text span */
  span {
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: ${Colors.primaryBlack};
  }

  /* hover */
  :hover {
    div {
      background-color: ${Colors.primaryBlack};

      /* icon svg */
      svg {
        color: ${Colors.white};
      }
    }
  }

  /* click  & active*/
  :active {
    div {
      background-color: ${Colors.secondaryBlack};

      /* icon svg */
      svg {
        color: ${Colors.white};
      }
    }

    /* text span */
    span {
      color: ${Colors.secondaryBlack};
    }
  }

  /* mobile */
  ${Responsive.mobile} {
    /* icon div */
    div {
      width: 40px;
      height: 40px;
      margin-right: 12px;

      /* icon svg */
      svg {
        height: 12px;
        width: 12px;
        min-width: 12px;
        color: ${Colors.primaryBlack};
      }
    }
  }
`
//
export default AddButton
